<template>
  <div>
    <vuestic-modal ref="openModal" :large="true">
      <h5 slot="header">Ajustes</h5>
      <table class="table table-bordered">
        <thead class="thead-dark">
        <tr>
          <th>Fecha</th>
          <th>Tipo</th>
          <th>Usuario</th>
          <th>Motivo</th>
          <th>Comentario</th>
          <th>Cantidad</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="ajuste in ajustes">
          <td>{{ ajuste.created_at | fecha }}</td>
          <td>{{ ajuste.tipo.toUpperCase() }}</td>
          <td>{{ ajuste.usuario.nombre.toUpperCase() }}</td>
          <td>{{ ajuste.motivo.toUpperCase() }}</td>
          <td>{{ ajuste.comentario.toUpperCase() }}</td>
          <td>{{ ajuste.cantidad }}</td>
        </tr>
        </tbody>
      </table>
    </vuestic-modal>
  </div>

</template>
<script>
  import VuesticModal from "../../../vuestic-theme/vuestic-components/vuestic-modal/VuesticModal";
  import moment from 'moment'
  export default {
    name: 'modalAjustes',
    props: ['ajustes', 'productoId'],
    components: {VuesticModal},
    methods: {
      openModal() {
        this.$refs.openModal.open()
      }
    },
    filters: {
      fecha: function(value) {
        return moment(value).format('DD/MM/YYYY')
      },
      costo: function(value) {
        return parseInt(value.precioUnitario  - (value.precioUnitario * (value.descuento / 100)), 10)

      }
    }
  }
</script>
